<template>
    <div class="guide-picture-wrapper">
        <CoverPanel
            :noCoverIcon="noCoverIcon"
            :imageUrl="data.image"
            :operateIcons="operateIcons"
            :viewIcon="viewIcon"
            @viewClick="viewHandler"
            @uploadCover="uploadImageHandle"
            @operatorSelect="operatorSelect"
        />
    </div>
</template>

<script>
import CoverPanel from "@/views/zhiji/components/questionEdit/answers/widgets/CoverPanel";

export default {
    name: "GuidePicture",
    props: ["data"],
    components: {
        CoverPanel
    },
    data() {
        return {
            viewIcon: {
                position: "-110px -85px"
            }
        };
    },
    computed: {
        noCoverIcon() {
            return {
                position: "-145px -50px",
                label: this.$t("zhiji.answer.addPicture")
            };
        },
        operateIcons() {
            return [
                {
                    type: "updateImage",
                    position: "-38px -77px",
                    name: this.$t("zhiji.materialLibrary.replacePic")
                },
                {
                    type: "updateCover",
                    position: "-38px -77px",
                    name: this.$t("zhiji.answer.replaceCover")
                }
            ];
        }
    },
    methods: {
        uploadImageHandle() {
            this.uploadImage(false, imageUrl => {
                this.commitUpdate({
                    cardImage: imageUrl,
                    image: imageUrl
                });
            });
        },
        uploadImage(needClip, cb) {
            this.$store.commit("zhiji/showModal", {
                type: "ImageClipModal",
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: needClip
                }
            });

            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        },
        viewHandler() {
            this.$store.commit("zhiji/showModal", {
                type: "ImageViewModal",
                data: {
                    url: this.data.image
                }
            });
        },
        operatorSelect(type) {
            if (type === "updateImage") {
                this.uploadImage(false, imageUrl => {
                    this.commitUpdate({
                        image: imageUrl,
                        cardImage: imageUrl
                    });
                });
            } else if (type === "updateCover") {
                this.uploadImage(true, imageUrl => {
                    this.commitUpdate({
                        cardImage: imageUrl
                    });
                });
            }
        },
        commitUpdate(updateData) {
            updateData.updateState = "update";
            let newData = Object.assign({}, this.data, updateData);
            this.$emit("updateContent", newData);
        }
    }
};
</script>

<style lang="scss" scoped>
.guide-picture-wrapper {
    position: relative;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    font-size: 12px;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 200px;
}
</style>
